import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Tempo verschillen per herhaling, wat doet het?</title>
                <link rel="canonical" href={route("blogs.thirty")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE personal training Uden en Schijndel komt met een nieuwe blog. In deze blog bespreken we een onderdeel uit de krachttraining, namelijk de snelheid van de herhalingen die we per set maken. De een met zijn herhalingen vlot terwijl een ander een hele langzame beweging maakt. In deze blog beantwoorden we de vraag: wat voor effect heeft dit op de output?"
                />
                <meta
                    property="og:description"
                    content="WE ARE personal training Uden en Schijndel komt met een nieuwe blog. In deze blog bespreken we een onderdeel uit de krachttraining, namelijk de snelheid van de herhalingen die we per set maken. De een met zijn herhalingen vlot terwijl een ander een hele langzame beweging maakt. In deze blog beantwoorden we de vraag: wat voor effect heeft dit op de output?"
                />
                <meta property="og:url" content={route("blogs.thirty")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Tempo verschillen per herhaling, wat doet het? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/tempo.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/tempo.webp"
                                    type="image/webp"
                                    alt="Tempo"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/tempo.jpg"
                                    type="image/jpeg"
                                    alt="Tempo"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/tempo.jpg"
                                    alt="Tempo"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Tempo verschillen per herhaling, wat doet het?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE personal training Uden en Schijndel komt met een
                        nieuwe blog. In deze blog bespreken we een onderdeel uit
                        de krachttraining, namelijk de snelheid van de
                        herhalingen die we per set maken. De een met zijn
                        herhalingen vlot terwijl een ander een hele langzame
                        beweging maakt. In deze blog beantwoorden we de vraag:
                        wat voor effect heeft dit op de output?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Excentrisch, concentrisch en pauze
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Om te beginnen is het nodig om uit te leggen dat de
                        herhalingen die worden gemaakt bestaan uit drie
                        verschillende fases. Als voorbeeld nemen we een bankdruk
                        oefening. Tijdens deze oefening neem je de stang uit het
                        rek en neemt even ‘pauze’. Hierbij hangt de stang stil
                        boven je en bereid je jezelf voor om de stang te laten
                        zakken (excentrische fase). Terwijl je de stang laat
                        zakken verlengen je spieren. Ze komen op rek tijdens
                        deze excentrische fase. Wanneer je beneden bent
                        gearriveerd neem je weer even ‘pauze’ om de snelheid uit
                        de oefening te halen. Wanneer je enkele seconden ‘pauze’
                        hebt genomen druk je de stang weer met alle kracht die
                        je in je hebt omhoog (concentrische fase). Tijdens deze
                        fase verkorten je spieren en span je de desbetreffende
                        spier aan. Dit noemen we de concentrische beweging.
                        Eenmaal boven neem je weer even ‘pauze’ en begin je aan
                        herhaling twee.
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li>Excentrische fase (er komt rek op de spier)</li>
                        <li>Concentrische fase (de spier verkort)</li>
                        <li>Pauze (de fases tussen ex,- en concentrisch)</li>
                    </ol>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom is tempo belangrijk?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het tempo van een herhaling is uiteindelijk bepalend
                        voor de output van je trainingen. Je kunt jezelf
                        voorstellen dat wanneer je bij het bankdrukken de stang
                        laat ‘vallen’ en vervolgens weer explosief uit te duwen
                        een heel andere output geeft dan wanneer je de stang in
                        vier seconden laat zakken en vervolgens weer in vier
                        seconden uit te duwen. De spanning en de metabole stress
                        van beide tempo’s zijn totaal verschillend.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De eeuwige discussie over de concentrische fase zal
                        zijn: langzaam of explosief? Onderzoeken die zijn gedaan
                        tonen aan dat explosieve bewegingen tijdens een
                        concentrische fase zorgen voor meer kracht ontwikkeling
                        (González-Badillo, 2014), Daarnaast zorgt een explosieve
                        concentrische fase ervoor dat je meer herhalingen kan
                        maken met meer gewicht. Dit zou kunnen leiden tot meer
                        spierontwikkeling.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De excentrische fase is de meest onderschatte fase. Deze
                        fase is de fase waarbij zwaartekracht zijn werk doet.
                        Wanneer we geen weerstand bieden tijdens deze fase zal
                        het gewicht ‘vallen’ zonder er iets voor te doen.
                        Belangrijk is om weerstand te bieden tijdens deze fase
                        zodat onze spieren moeten werken en geprikkeld wordt.
                        Een belangrijk feitje om te weten dat ons lichaam
                        excentrisch 20% sterker is dan concentrisch. Dus wanneer
                        je excentrisch niet sterker wordt zal je concentrische
                        fase ook niet toenemen om het lichaam niet in gevaar te
                        brengen. Dit is een van de redenen waarom het belangrijk
                        is om weerstand te bieden tijdens de excentrische fase.
                        De tweede reden is al eerder genoemd, namelijk dat er
                        geen spieractiviteit plaatsvindt wanneer je het gewicht
                        laat ‘vallen’.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Welke tempo moet je aanhouden?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het tempo wat je dient aan te houden is per oefening en
                        per persoon afhankelijk. Wanneer iemand met een lengte
                        van twee meter een back squat maakt doet hij er relatief
                        langer over om te zakken dan wanneer iemand met een
                        lengte van 1,60 meter dit doet. Daarnaast zijn de
                        bewegingsuitslagen van oefeningen verschillend dus
                        bestaat er geen heilig tempo.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Concluderend
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Belangrijk om mee te nemen uit deze blog is om te weten
                        dat elke beweging uit drie fases bestaat. Om maximale
                        spierkracht en ontwikkeling te veroorzaken raden we aan
                        om het gewicht explosief uit te duwen en langzaam te
                        laten zakken in een tempo van ongeveer drie tot vier
                        seconden, afhankelijk van oefening en lengte. Deze
                        manier van training biedt ook de meeste veiligheid om
                        blessures te voorkomen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Heb je ook al onze blog gelezen over{" "}
                        <a
                            href={route("blogs.twenty-eight")}
                            className="text-we-are-yellow"
                        >
                            genetische aanleg
                        </a>
                        ?
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        González-Badillo, J. J. (2014, April 15). European
                        Journal of Sport Science . Opgehaald van:{" "}
                        <a
                            href="https://www.tandfonline.com/doi/abs/10.1080/17461391.2014.905987"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://www.tandfonline.com/doi/abs/10.1080/17461391.2014.905987{" "}
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
